import { format as formatDate } from "date-fns";

import { localSettingObservable } from "./localSettingObservable";
import { toUtc } from "./toUtc";

class NakedUTC {
    @localSettingObservable("utc")
    readonly utc: boolean = false;
}

const nakedUTC = new NakedUTC();

export function formatDateString(date: Date, format: string) {
    if (nakedUTC.utc) {
        date = toUtc(date);
    }
    return formatDate(date, format);
}
